import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/league/settle/list',
      data
    });
  },
  createSettle(data) {
    return http.post({
      url: '/la/admin/league/settle/create',
      data,
      dataType: 'form'
    });
  },
  revertSettle(data) {
    return http.post({
      url: '/la/admin/league/settle/cancel',
      data,
      dataType: 'form'
    });
  },
  getSettleTotal(data) {
    return http.get({
      url: '/la/admin/league/settle/record/total',
      data
    });
  }
};
